// Single source of truth for "is this account payment-restricted?", shared by
// the router guard (src/router/index.ts) and the profile menu (ProfileDD.vue)
// so the access rule and the visible menu can never drift apart.
//
// Restricted = any payment-failed state: past_due (still retrying) as well as
// unpaid / expired / canceled (max retries reached). Shape comes from
// GET /getusersubscriptiondata.
export function isRestrictedSubscription(res: any): boolean {
    const status = res?.status;
    return (
        res?.subscription_expired === true ||
        ['past_due', 'unpaid', 'expired', 'canceled'].includes(status)
    );
}
